import { CollegeFamilies, CollegeFamilyVerified } from "infrastructure/services/types/college.entity";
import { RootState } from "./rootReducer";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: CollegeFamilies = [];
// const initialState: CollegeFamilies = [{
//   college: {},
//   familyId: '',
// } as CollegeFamilyVerified] as CollegeFamilies;

export const collegeFamilyReducer = createSlice({
  name: "CollegeFamilyReducer",
  initialState,
  reducers: {
    saveCollegeFamily: (state, action: PayloadAction<CollegeFamilyVerified>) => {
      state.push(action.payload);
    },
    resetCollegeFamily: () => [],
    setCollegeFamilies: (state, action: PayloadAction<CollegeFamilyVerified[]>) => {
      return action.payload;
    }
  },
});

export const { resetCollegeFamily, saveCollegeFamily, setCollegeFamilies } = collegeFamilyReducer.actions;

export const getCollegeFamilyRedux = (state: RootState) => state.collegeFamilyReducer;

export default collegeFamilyReducer.reducer;
